






























































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import Icon from '@/components/Icon.vue'
import { CommentModule } from '@/store/modules/comment.module'
import { EUserStatus, IUser } from '@zunta/configurations'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import ScrollView from '@/components/ScrollView.vue'
import Mentions from '@/components/Mentions.vue'
import { UserModule } from '@/store/modules/user.module'
import { CommentUserOptions } from '@/interfaces'

const moment: any = require('moment')
const countdown: any = require('moment-countdown')

@Component({
  components: {
    Mentions,
    ScrollView,
    Icon,
    DateTimeLabel
  },
  props: {
    letterID: {
      default: null
    },
    statementID: {
      default: null
    }
  }
})
export default class Comments extends Vue {
  commentsModuleInstance: CommentModule = getModule(CommentModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  textMessage: string = ''
  isLoading: boolean = false

  get selectedBatch () {
    return this.$store.state.batch.selectedBatch
  }

  get usersOptions (): CommentUserOptions[] {
    if (!this.selectedBatch || !this.userModuleInstance.users || !this.userModuleInstance.users.length) {
      return []
    }

    return this.userModuleInstance.users
        .filter((item: IUser) => {
          return item.status === EUserStatus.ACTIVE &&
            (item.isAllFacilities || item.facilities.map((facility: any) => Number(facility)).includes(this.selectedBatch.facility.id))
        })
        .map((item: IUser) => {
          return {
            label: `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''}`,
            key: `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''}`,
            replaceValue: item.id,
            value: `${item.firstName ? item.firstName : ''}${item.lastName ? item.lastName : ''}`.split(' ').join('')
          }
        })
  }

  get commentList () {
    return this.$store.state.comment.comments
  }

  @Watch('statementID')
  onStatementChanged () {
    this.textMessage = ''
  }

  @Watch('letterID')
  onLetterChanged () {
    this.textMessage = ''
  }

  updated () {
    this.scrollDown()
  }

  async update () {
    if (this.$props.statementID) {
      await this.commentsModuleInstance.fetchStatementComments(this.$props.statementID)
    }
  }

  scrollDown () {
    const area: any = document.querySelector('#comment-scroll-wrapper')
    if (!area) return
    area.scrollTo({
      top: area.scrollHeight
    })
  }

  mounted () {
    this.scrollDown()
    this.$watch('commentList', () => {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.scrollDown()
      })
    }, { immediate: true })
    this.$eventBus.$on('comments:update', this.update)
  }

  async submitMessage (text: string) {
    console.log('text', text)
    if (!text || !text.trim().length || this.isLoading) {
      return
    }
    this.isLoading = true

    await this.commentsModuleInstance.createComment({
      text: text,
      statement: this.$props.statementID ? parseInt(this.$props.statementID, 10) : undefined,
      letter: this.$props.letterID ? parseInt(this.$props.letterID, 10) : undefined
    })

    if (this.$props.statementID) {
      await this.commentsModuleInstance.fetchStatementComments(this.$props.statementID)
    }

    this.textMessage = ''
    this.isLoading = false
  }

  formattedCommentText (commentText: string) {
    console.log(commentText)
    return commentText.replace(/\n/g, '<br>')
  }
}
